import { render, staticRenderFns } from "./ImportWordDocument.vue?vue&type=template&id=b5662622&scoped=true&"
import script from "./ImportWordDocument.vue?vue&type=script&lang=js&"
export * from "./ImportWordDocument.vue?vue&type=script&lang=js&"
import style0 from "./ImportWordDocument.vue?vue&type=style&index=0&id=b5662622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5662622",
  null
  
)

export default component.exports